const typList = [
    { name: 'ถังดับเพลิงชนิดโฟม (Foam Extinguishers)', value: 'F' },
    { name: 'ถังดับเพลิงสูตรน้ำ (Low Pressure Water Mist)', value: 'L' },
    { name: 'ถังดับเพลิงชนิดผงเคมีแห้ง (Dry Chemical)', value: 'D' },
    { name: 'ถังดับเพลิงชนิดก๊าซคาร์บอนไดออกไซด์ ( CO2 )', value: 'C' },
    { name: 'ถังดับเพลิงชนิดน้ำ (Water Extinguishers)', value: 'W' }
];
const methods = {
    generateExtinguisher() {
        console.log('object');
    },
    onExtinguisherGenerated(data) {
        console.log('Generated extinguishers:', data);
    },
    onOrganizationAssigned(data) {
        console.log('Generated extinguishers:', data);
    }
};

export default { ...methods };
